<!--
 * @Descripttion: 
 * @version: 
 * @Author: wutao
 * @LastEditors: wutao
 * @LastEditTime: 2025-08-22 15:38:27
-->
<template>
    <div>
        <!-- <div class="top_hytitle" style="margin-top: 0;">
              <div class="letf_line"></div>
              <div class="center_text">欢迎回来</div>
              <div class="right_line"></div>
            </div> -->
        <div class="">
            <div class="top-box">
                <p class="text">亲爱的客户，生日快乐！</p>
                    <img src="../../assets//iconIndex/srtx_img.png" alt="" class="img-br">
                    <p class="text2">感谢一直以来的信任，愿新岁账户长红，收益如春笋节节高～在这特别的日子里，为你奉上专属心意：</p>
                <div class="top-box-btn">去领取</div>
            </div>
        </div>
    </div>
</template>

<script>
import { } from "@/utils/common";
import { Toast } from "vant";
import commonFunc from "@/utils/ysjh";
export default {
    data() {
        return {};
    },
    props: {
        topList: {
            type: Object,
            default: () => { },
        },
    },
    watch: {},
    mounted() { },
    created() { },
    methods: {
        formatTimestamp(ms) {
            if (!ms) {
                return "";
            }
            const time = Number(ms);
            if (!time || isNaN(time)) return "-";
            const d = new Date(time);
            const Y = d.getFullYear();
            const M = String(d.getMonth() + 1).padStart(2, "0");
            const D = String(d.getDate()).padStart(2, "0");
            const h = String(d.getHours()).padStart(2, "0");
            const m = String(d.getMinutes()).padStart(2, "0");
            const s = String(d.getSeconds()).padStart(2, "0");
            return `${Y}-${M}-${D} ${h}:${m}:${s}`;
        },
    },
};
</script>

<style lang="less" scoped>
.img-br{
    width: 248px;
    height: 140px;
    margin: 0 auto 0 auto;
}
.top-box{
    justify-content: center;
    display: flex;
    flex-direction: column;
}
.text{
    text-align: center;
    margin-bottom: 5px;
    font-weight: 500;
    font-size: 14px;
}
.text2{
    line-height: 25px;
}
</style>